<template>

    <div>

        <b-row>

            <b-col lg="12">

                <b-card>

                    <b-row>

                        <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                            <date-picker
                                    v-model="start_date"
                                    placeholder="Submitted From"
                                    class="f-1">
                            </date-picker> &nbsp;to&nbsp;
                            <date-picker
                                    v-model="end_date"
                                    placeholder="Submitted To"
                                    class="f-1">
                            </date-picker>
                        </b-col>

                        <b-col sm="6" md="4" class="my-1" v-if=" client == null ">

                            <user-role-search-dropdown type="claimant" v-model=" client_id "></user-role-search-dropdown>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1">

                            <b-form-select v-model=" invoice_type " class="mx-1 mb-1">

                                <option value="">All Invoices</option>
                                <option value="original">Original Only</option>
                                <option value="revised">Revised Only</option>
                            </b-form-select>
                        </b-col>
                        <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                            <date-picker
                                    v-model="created_from"
                                    placeholder="Created From"
                                    class="f-1">
                            </date-picker> &nbsp;to&nbsp;
                            <date-picker
                                    v-model="created_to"
                                    placeholder="Created To"
                                    class="f-1">
                            </date-picker>
                        </b-col>

                        <b-col sm="6" md="4" class="my-1">

                            <carrier-parents-dropdown v-model=" parent_carrier " v-if=" !carrier_preselect "></carrier-parents-dropdown>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1">

                            <carrier-dropdown v-model=" carrier " v-if=" !carrier_preselect "></carrier-dropdown>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">

                        <b-col class="d-flex align-items-center justify-content-end">

                            <b-button variant="success" :disabled=" loading " @click=" exportXls() " class="mr-1">Export to Excel</b-button>
                            <b-button variant="info" :disabled=" loading " @click=" loadTable() ">Generate Report</b-button>
                        </b-col>
                    </b-row>

                    <loading-card v-if="loading" :message="this.loading_message" />


                    <div id="loader" v-show="downloading">
                      <b-spinner label="Spinning"></b-spinner>
                    </div>

                    <div class="table-responsive" v-show="!loading">

                        <b-table bordered striped hover show-empty
                            :items=" items "
                            :fields=" fields "
                            :current-page=" currentPage "
                            :per-page=" 0 "
                            :sort-by.sync=" sortBy "
                            :sort-desc.sync=" sortDesc "
                        >
                          <template v-slot:cell(generated)="data">

                            <div v-if="data.item.pdf">
                              <b-button variant="secondary" @click="downloadSaved(data.item, 'pdf')"><i class="fa fa-file-pdf-o" style="color: red;"></i> PDF</b-button>
                            </div>
                            <div v-if="data.item.tiff">
<b-button variant="secondary" @click="downloadSaved(data.item, 'tiff')" ><i class="fa fa-file-image-o" style="color: navy;"></i> TIFF</b-button>
                            </div>

                            <div v-if="!data.item.pdf && !data.item.tiff">
                              <b-button variant="secondary" :href=" `/${controller}/invoices/${data.item.id}/print`" target="_blank" class="dynamic-link"><i class="fa fa-file-pdf-o" style="color: red;"></i> PDF</b-button>
                              <b-button variant="secondary" :href="`/${controller}/invoices/${data.item.id}/print/tiff`" target="_blank" class="dynamic-link"><i class="fa fa-file-image-o" style="color: navy;"></i> TIFF</b-button>
                            </div>

                          </template>
                          <template v-slot:cell(actions)="data">
                              <b-button variant="secondary" :href=" `/${controller}/invoices/${data.item.id}/print`" target="_blank"><i class="fa fa-file-pdf-o" style="color: red;"></i> PDF</b-button>
                              <b-button variant="secondary" :href="`/${controller}/invoices/${data.item.id}/print/tiff`" target="_blank"><i class="fa fa-file-image-o" style="color: navy;"></i> TIFF</b-button>
                          </template>
                          <template v-slot:cell(approved_on)="data">
                            <span v-html="getApprovedOnData(data.item)" />
                          </template>
                          <template v-slot:cell(dispatch)="data">
                            <div v-if="isHighLevel">
                              <div v-show="!data.item.is_approved">
                                <b-button variant="secondary" @click="approve(data.item)">Validate</b-button>
                              </div>
                            </div>
                          </template>
                          <template v-slot:cell(created_at)="data">
                            <utc-time timezone="America/Chicago" :role="role" :time="data.item.created_at" format="MM/DD/YYYY" />
                          </template>
                          <template v-slot:cell(approved_on)="data">
                            <utc-time timezone="America/Chicago" :role="role" :time="data.item.approved_on ? data.item.approved_on : ''" format="MM/DD/YYYY" />
                          </template>
                          <template v-slot:cell(submitted_at)="data">
                            <utc-time timezone="America/Chicago" :role="role" :time="data.item.submitted_at ? data.item.submitted_at : 'Pending'" format="MM/DD/YYYY" />
                          </template>
                        </b-table>
                    </div>
                    <b-row>
                        <b-col lg="6">
                            <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                        </b-col>
                        <b-col lg="6" class="text-right">
                            {{ paginationText }}
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import FormatsDates from "../../../mixins/FormatsDates";
    import FormatsNumbers from "../../../mixins/FormatsNumbers";
    import HasCarrierDropdowns from '../../../mixins/HasCarrierDropdowns';
    import ScopesToCarrier from '../../../mixins/ScopesToCarrier';
    import PaginatedTable from '../../../mixins/PaginatedTable';
    import UsesRole from '../../../mixins/UsesRole';
    import ScopesToUser from '../../../mixins/ScopesToUser';
    import DownloadsFiles from '../../../mixins/DownloadsFiles'

    export default {
        name: "SubmittedInvoicesReport",
        mixins: [ FormatsDates, FormatsNumbers, HasCarrierDropdowns, ScopesToCarrier, PaginatedTable, UsesRole, ScopesToUser, DownloadsFiles ],
        data() {
            return {
                default_loading_message : 'Loading Results...',
                loading_message : '',
                downloading: false,
                start_date     : '',
                created_from   : '',
                end_date       : '',
                created_to     : '',
                client_id      : '',
                invoice_type   : '',
                fields: [
                    {
                        key: 'name',
                        label: 'Invoice #',
                        sortable: true,
                    },
                    {
                        key: 'client_name',
                        sortable: true,
                    },
                    { key: 'carrier', sortable: true },
                    {
                      key: 'created_at',
                      label: 'Date Created',
                      // formatter: (val) => this.formatDateFromUTC(val),
                      sortable: true,
                    },
                    {
                        key: 'approved_on',
                        label: 'Validated On',
                        // formatter: (val) => val ? this.formatDateFromUTC(val) : '',
                        sortable: true,
                    },
                    {
                      key: 'submitted_at',
                      label: 'Date Submitted',
                      // formatter: (val) => val ? this.formatDateFromUTC(val) : 'Pending',
                      sortable: true,
                    },
                    {
                        key: 'hours',
                        formatter: (val) => this.numberFormat(val),
                        sortable: true,
                    },
                    {
                        key: 'amount',
                        formatter: (val) => this.moneyFormat(val),
                        sortable: true,
                    },
                    {
                        key: 'generated',
                        class: 'hidden-print',
                        label: 'Invoices',
                    },
                  // {
                  //   key: 'actions',
                  //   class: 'hidden-print',
                  //   label: 'Dynamic Reports',
                  // },
                  // {
                  //   key: 'dispatch',
                  //   class: 'hidden-print',
                  //   label: 'Validate',
                  // },
                ]
            }
        },

        computed: {
            baseUrl(){
              return `/${this.controller}/reports/submitted-invoices`;
            },
            appliedFilters(){ return `?json=1&timezone=America/Chicago&start_date=${this.start_date}&end_date=${this.end_date}&created_from=${this.created_from}&created_to=${this.created_to}&client_id=${this.client_id}&invoice_type=${this.invoice_type}&carrier=${this.carrier_query_string}`; }
        },
        methods: {
          getApprovedOnData(item) {
            if (item.approved_on === null && item.is_approved) {
              if (item.submitted_at) {
                return this.formatDateFromUTC(item.submitted_at);
              }
              return (new Date()).toLocaleDateString();
            }
            if (item.approved_on === null) {
              return '';
            }
            return this.formatDateFromUTC(item.approved_on);
          },
          async approve(item) {
            const form = new Form();
            const url = `/${this.controller}/invoices/approve/${item.id}`;
            try {
              await form.post(url);
              this.items.forEach(el => {
                if (el.id == item.id) {
                  item.approved_on = (new Date()).toLocaleDateString();
                }
              });
            } finally {
              this.loading = false;
              this.loading_message = this.default_loading_message;
            }
          },
          async dispatchInvoice(item) {
            const form = new Form();
            const url = `/${this.controller}/invoices/dispatch/${item.id}`;
            try {
              this.loading_message = 'Dispatching invoice...';
              this.loading = true;
              await form.post(url);
              this.items.forEach(el => {
                if (el.id == item.id) {
                  item.submitted_at = (new Date()).toLocaleDateString();
                }
              });
            } finally {
              this.loading = false;
              this.loading_message = this.default_loading_message;
            }
          },
          downloadSaved(item, format = 'pdf') {
            const url = `/generated-invoices/${item.id}`;
            const data = {
              url,
              method: 'POST',
              data: {
                format,
              }
            }
            this.loading_message = 'Downloading File...';
            this.downloading = true;
            this.downloadFile(data).finally(() => {
              this.downloading = false;
            })
          }
        },
      created() {
          this.loading_message = this.default_loading_message;
      }
    }
</script>

<style scoped>
.dynamic-link {
  border-width: 2px;
  border-color: green;
}

#loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  align-content: center;
  display: flex;
  justify-content: center;
  z-index: 2;
  background: rgba(0, 0, 0, 0.3);
}
</style>
